(() => {
  if (window.__sculptaDrLoaded) {
    if (window.__sculptaDrInit) window.__sculptaDrInit();
    return;
  }

  window.__sculptaDrLoaded = true;

  const money = (value) => '$' + value;
  const pageQuery = (selector) => document.querySelector(selector);
  const pageQueryAll = (selector) => Array.from(document.querySelectorAll(selector));

  function scrollToTarget(targetSelector, block = 'center') {
    const target = pageQuery(targetSelector);
    if (target) target.scrollIntoView({ behavior: 'smooth', block });
  }

  function initSculptaDr(root) {
    if (root.dataset.scdrInitialized === 'true') return;
    root.dataset.scdrInitialized = 'true';

    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => Array.from(root.querySelectorAll(selector));

    root.addEventListener('click', (event) => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || !root.contains(anchor)) return;
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      const target = pageQuery(href);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    $$('[data-scdr-scroll]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        scrollToTarget(trigger.dataset.scdrScroll);
      });
    });

    const timer = $('[data-scdr-timer]');
    if (timer) {
      let remaining = 4 * 3600 + 12 * 60;
      const tick = () => {
        if (remaining <= 0) remaining = 24 * 3600;
        const h = Math.floor(remaining / 3600);
        const m = Math.floor((remaining % 3600) / 60);
        const s = remaining % 60;
        timer.textContent = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
        remaining -= 1;
      };
      tick();
      setInterval(tick, 1000);
    }

    const mainImage = $('[data-scdr-main-img]');
    $$('.gallery-thumbs button').forEach((button) => {
      button.addEventListener('click', () => {
        $$('.gallery-thumbs button').forEach((item) => item.classList.remove('active'));
        button.classList.add('active');
        if (mainImage && button.dataset.img) mainImage.src = button.dataset.img;
      });
    });

    $$('.video-card[data-scdr-video-card]').forEach((card) => {
      const video = card.querySelector('video');
      if (!video) return;

      const loadVideo = () => {
        if (video.dataset.scdrLoaded === 'true') return;
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.preload = 'metadata';
        video.load();
        video.dataset.scdrLoaded = 'true';
      };

      card.addEventListener('click', () => {
        $$('.video-card video').forEach((item) => {
          if (item !== video) {
            item.pause();
            item.closest('.video-card')?.classList.remove('is-playing');
          }
        });

        if (video.paused) {
          loadVideo();
          video.play().catch(() => {});
          card.classList.add('is-playing');
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      });

      video.addEventListener('play', () => card.classList.add('is-playing'));
      video.addEventListener('pause', () => card.classList.remove('is-playing'));
      video.addEventListener('ended', () => card.classList.remove('is-playing'));
    });

    const ctaText = $('[data-scdr-cta-text]');
    const stickyPrice = pageQuery('[data-scdr-sticky-price]');
    const stickyOld = pageQuery('[data-scdr-sticky-old]');
    $$('.qty-opt').forEach((option) => {
      option.addEventListener('click', () => {
        $$('.qty-opt').forEach((item) => item.classList.remove('selected'));
        option.classList.add('selected');
        const total = option.dataset.total;
        const was = option.dataset.was;
        if (ctaText) ctaText.textContent = 'ADD TO CART · ' + money(total);
        if (stickyPrice) stickyPrice.textContent = money(total);
        if (stickyOld) stickyOld.textContent = money(was);
      });
    });

    const beforeAfterStage = $('[data-scdr-ba-stage]');
    const beforeAfterBefore = $('[data-scdr-ba-before]');
    const beforeAfterHandle = $('[data-scdr-ba-handle]');
    if (beforeAfterStage && beforeAfterBefore && beforeAfterHandle) {
      let dragging = false;
      const setPosition = (pct) => {
        const next = Math.max(0, Math.min(100, pct));
        beforeAfterBefore.style.clipPath = 'inset(0 ' + (100 - next) + '% 0 0)';
        beforeAfterHandle.style.left = next + '%';
      };
      const getX = (event) => event.touches ? event.touches[0].clientX : event.clientX;
      const onMove = (event) => {
        if (!dragging) return;
        const rect = beforeAfterStage.getBoundingClientRect();
        const pct = ((getX(event) - rect.left) / rect.width) * 100;
        setPosition(pct);
        event.preventDefault();
      };
      beforeAfterStage.addEventListener('mousedown', (event) => { dragging = true; onMove(event); });
      beforeAfterStage.addEventListener('touchstart', (event) => { dragging = true; onMove(event); }, { passive: false });
      window.addEventListener('mousemove', onMove);
      window.addEventListener('touchmove', onMove, { passive: false });
      window.addEventListener('mouseup', () => { dragging = false; });
      window.addEventListener('touchend', () => { dragging = false; });
      setTimeout(() => {
        let p = 50;
        let dir = -1;
        let count = 0;
        const auto = setInterval(() => {
          p += dir * 1.5;
          if (p < 25 || p > 75) {
            dir *= -1;
            count += 1;
          }
          setPosition(p);
          if (count > 3) {
            clearInterval(auto);
            setPosition(50);
          }
        }, 30);
      }, 800);
    }

    $$('.faq-q').forEach((question) => {
      question.addEventListener('click', () => question.parentElement.classList.toggle('open'));
    });

    const sticky = $('[data-scdr-sticky]');
    const buy = pageQuery('[data-scdr-buy]');
    if (sticky && buy) {
      let last = false;
      const checkSticky = () => {
        const rect = buy.getBoundingClientRect();
        const visible = rect.top < window.innerHeight && rect.bottom > 0;
        const show = window.scrollY > 600 && !visible;
        if (show !== last) {
          sticky.classList.toggle('show', show);
          last = show;
        }
      };
      window.addEventListener('scroll', checkSticky);
      checkSticky();
    }

    const error = $('[data-scdr-error]');
    const setError = (message) => {
      if (!error) return;
      error.textContent = message;
      error.hidden = !message;
    };

    const buildCartItems = (productRoot, selected) => {
      const variantId = Number(productRoot ? productRoot.dataset.scdrVariantId : '');
      const mainQuantity = selected ? Number(selected.dataset.qty || 1) : 1;
      const items = [{ id: variantId, quantity: mainQuantity }];
      const extraIds = (selected?.dataset.extraVariantIds || '').split(',').filter(Boolean);
      const extraQuantities = (selected?.dataset.extraQuantities || '').split(',');

      extraIds.forEach((id, index) => {
        const extraVariantId = Number(id);
        if (!extraVariantId) return;
        items.push({
          id: extraVariantId,
          quantity: Number(extraQuantities[index] || 1) || 1
        });
      });

      return items.reduce((merged, item) => {
        const existing = merged.find((entry) => entry.id === item.id);
        if (existing) {
          existing.quantity += item.quantity;
        } else {
          merged.push(item);
        }
        return merged;
      }, []);
    };

    const showCartDrawer = (cartState, fallbackUrl) => {
      const drawer = pageQuery('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && cartState.sections) {
        if (!cartState.id && cartState.items && cartState.items[0]) cartState.id = cartState.items[0].id;
        drawer.renderContents(cartState);
        return true;
      }

      window.location.href = fallbackUrl || '/cart';
      return false;
    };

    async function addSelectedToCart(trigger) {
      const productRoot = trigger.closest('[data-sculpta-dr]');
      const variantId = productRoot ? productRoot.dataset.scdrVariantId : '';
      if (!variantId) {
        setError(productRoot?.dataset.scdrError || 'Choose a product for this section in the theme editor.');
        scrollToTarget('#scdr-qty-select');
        return;
      }

      const selected = productRoot.querySelector('.qty-opt.selected') || productRoot.querySelector('.qty-opt') || pageQuery('.qty-opt.selected') || pageQuery('.qty-opt');
      const items = buildCartItems(productRoot, selected);
      const original = trigger.innerHTML;
      trigger.classList.add('is-loading');
      trigger.innerHTML = trigger.dataset.loading || 'ADDING...';
      setError('');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        });
        const cartState = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(cartState.description || 'Cart add failed');
        trigger.classList.remove('is-loading');
        trigger.innerHTML = original;
        showCartDrawer(cartState, productRoot?.dataset.scdrCartUrl || '/cart');
      } catch (errorEvent) {
        setError(productRoot?.dataset.scdrError || 'Could not add this item to cart. Please try again.');
        trigger.classList.remove('is-loading');
        trigger.innerHTML = original;
      }
    }

    $$('[data-scdr-atc]').forEach((button) => {
      button.addEventListener('click', () => addSelectedToCart(button));
    });
  }

  function revealVisibleElements() {
    const reveals = pageQueryAll('.sculpta-dr-page .reveal:not([data-scdr-reveal-ready])');
    reveals.forEach((element) => {
      element.dataset.scdrRevealReady = 'true';
    });

    if (!reveals.length) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      reveals.forEach((element) => observer.observe(element));
    } else {
      reveals.forEach((element) => element.classList.add('in'));
    }
  }

  function initAll() {
    pageQueryAll('[data-sculpta-dr]').forEach(initSculptaDr);
    revealVisibleElements();
  }

  window.__sculptaDrInit = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
